
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n286Child = []
  var n287Child = []
  n287Child.push(text("UUID"))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n287 = h('label', props, n287Child)
  n286Child.push(n287)
  var n288Child = []
  var n289Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "uuid"},{name:'value', val: shadow.uuid}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n289 = h('input', props, n289Child)
  n288Child.push(n289)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n288 = h('div', props, n288Child)
  n286Child.push(n288)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'uuid'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n286 = h('div', props, n286Child)
  n0Child.push(n286)
  var n290Child = []
  var n291Child = []
  n291Child.push(text("Major"))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n291 = h('label', props, n291Child)
  n290Child.push(n291)
  var n292Child = []
  var n293Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "major"},{name:'value', val: shadow.major},{name:'type', val: "number"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n293 = h('input', props, n293Child)
  n292Child.push(n293)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n292 = h('div', props, n292Child)
  n290Child.push(n292)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n290 = h('div', props, n290Child)
  n0Child.push(n290)
  var n294Child = []
  var n295Child = []
  n295Child.push(text("Minor"))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n295 = h('label', props, n295Child)
  n294Child.push(n295)
  var n296Child = []
  var n297Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "minor"},{name:'value', val: shadow.minor},{name:'type', val: "number"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n297 = h('input', props, n297Child)
  n296Child.push(n297)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n296 = h('div', props, n296Child)
  n294Child.push(n296)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n294 = h('div', props, n294Child)
  n0Child.push(n294)
  var n298Child = []
  var n299Child = []
  n299Child = n299Child.concat(text(t('.distance')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n299 = h('label', props, n299Child)
  n298Child.push(n299)
  var n300Child = []
  var n301Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "distance"},{name:'value', val: shadow.distance},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n301 = h('input', props, n301Child)
  n300Child.push(n301)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n300 = h('div', props, n300Child)
  n298Child.push(n300)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n298 = h('div', props, n298Child)
  n0Child.push(n298)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  